import { EDGE_TYPES } from "constants/flowDesigner";
import ButtonEdge from "layouts/Flow Designer/components/CustomEdges/ButtonEdge";
import FloatingEdge from "layouts/Flow Designer/components/CustomEdges/FloatingEdge";
import HiddenComponentEdge from "layouts/Flow Designer/components/CustomEdges/HiddenComponentEdge";
import LabelEdge from "layouts/Flow Designer/components/CustomEdges/LabelEdge";
import CommonComponentNode from "layouts/Flow Designer/components/CustomNodes/CommonComponentNode";
import CustomComponentNodeponentNode from "layouts/Flow Designer/components/CustomNodes/CustomComponentNode";
import HiddenNode from "layouts/Flow Designer/components/CustomNodes/HiddenNode";
import LabelNode from "layouts/Flow Designer/components/CustomNodes/LabelNode";
import PlaceholderNode from "layouts/Flow Designer/components/CustomNodes/PlaceholderNode";
import StaticNode from "layouts/Flow Designer/components/CustomNodes/StaticNode";
import { MarkerType } from "reactflow";
import SubFlowNode from "layouts/Flow Designer/components/CustomNodes/SubFlowNode";
import StraightEdge from "layouts/Flow Designer/components/CustomEdges/StraightEdge";

const nodeTypes = {
  custom: CustomComponentNodeponentNode,
  common: CommonComponentNode,
  static: StaticNode,
  placeholder: PlaceholderNode,
  label: LabelNode,
  hidden: HiddenNode,
  subflow: SubFlowNode
};

const edgeTypes = {
  [EDGE_TYPES.BUTTON]: ButtonEdge,
  [EDGE_TYPES.LABEL]: LabelEdge,
  [EDGE_TYPES.HIDDEN]: HiddenComponentEdge,
  [EDGE_TYPES.FLOATING]: FloatingEdge,
  [EDGE_TYPES.STRAIGHT]: StraightEdge
};

const defaultEdgeOptions = {
  deletable: false,
  type: EDGE_TYPES.BUTTON,
  markerEnd: { type: MarkerType.ArrowClosed, width: 14, height: 14, color: "#7443FF" },
  pathOptions: { offset: 3 }
};

export { nodeTypes, edgeTypes, defaultEdgeOptions };
